module.exports = __webpack_public_path__ + "img/bt.303ef8ac.svg";